const PHONE_REGEX = /^0(5[012345678]|6[47]){1}(-)?[^0\D]{1}\d{6}$/;

export const formatPhone = (phone) => {
    if (!phone) return '';
    const digits = phone.replace(/\D/g, '');
    return digits.length >= 9 ? `${digits.slice(0, 3)}-${digits.slice(3)}` : digits;
};
const EMAIL_REGEX = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;

export const isValidPhone = (phone) => phone === '' || PHONE_REGEX.test(phone);
export const isValidEmail = (email) => email === '' || EMAIL_REGEX.test(email);

export const hashPassword = async (text) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(text);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
};
